import { useSelector } from 'react-redux';
import { selectSessionSelector } from '@mm/state/selectors/userSelector';
import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { Routes } from '../../routes/top-level-routes';

export const useAuthenticatedRedirect = () => {
  const session = useSelector(selectSessionSelector);
  const history = useHistory();

  useEffect(() => {
    if (session) {
      history.push(Routes.chatbotEditor.getLink());
    }
  }, [session]);
};
